export default __webpack_public_path__ + "static/media/process_02.962f30e6.png";